var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SidbearSettingsGroup',{attrs:{"title":"Live Chat Settings","active":""}},[_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"mb-0 pb-0"},[_vm._v("Status")]),_c('div',{staticClass:"w-[129px]"},[_c('v-select',{attrs:{"options":[{label: 'Open Chat', value: '1'}, {label: 'Close Chat', value: '0'}],"searchable":false,"reduce":val => val.value},on:{"option:selected":_vm.onStatusChange},model:{value:(_vm.section.options.content.chat.status),callback:function ($$v) {_vm.$set(_vm.section.options.content.chat, "status", $$v)},expression:"section.options.content.chat.status"}})],1)])]),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Icon Color")]),_c('sid-color',{attrs:{"rule-name":"stroke","var":"--icon-color","sid":_vm.className(' .info .info-title svg path')}})],1)]),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","var":"--title-color","sid":_vm.className(' .info .info-title')}})],1)]),_c('sid-background',{attrs:{"sid":_vm.className()}}),_c('sid-range-slider',{attrs:{"rule-name":"gap","label":"Gap","sid":_vm.className(),"dimensions":[],"default-dimension":"px"}}),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":_vm.className(),"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":_vm.className(),"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
          {
            text: '',
            value: 'top-width'
          },
          {
            text: '',
            value: 'right-width'
          },
          {
            text: '',
            value: 'bottom-width'
          },
          {
            text: '',
            value: 'left-width'
          }
        ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":_vm.className(),"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":_vm.className(),"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
        {
          text: '',
          value: 'top-left-radius',
          cssVar: '--border-top-left-radius'
        },
        {
          text: '',
          value: 'top-right-radius',
          cssVar: '--border-top-right-radius'
        },
        {
          text: '',
          value: 'bottom-left-radius',
          cssVar: '--border-bottom-left-radius'
        },
        {
          text: '',
          value: 'bottom-right-radius',
          cssVar: '--border-bottom-right-radius'
        }
      ]}}),_c('b-form-group',{attrs:{"label":"Shadow Color"}},[_c('sid-box-shadow',{attrs:{"sid":_vm.className(),"rule-name":"box-shadow"}})],1)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Online Counter"}},[_c('sid-font',{attrs:{"sid":_vm.className(' .online-status')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' .online-status'),"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","var":"--title-color","sid":_vm.className(' .online-status')}})],1)]),_c('sid-background',{attrs:{"sid":_vm.className(' .online-status')}}),_c('sid-linked-group',{attrs:{"label":"Padding","sid":_vm.className(' .online-status'),"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Chat Box"}},[_c('b-form-group',[_c('sid-range-slider',{attrs:{"rule-name":"height","sid":_vm.className(),"default-dimension":"px","dimensions":['px', 'vh', '%'],"label":"Height","var":"--height","reset-value":"300px","measurement":"height"}})],1),_c('sid-background',{attrs:{"sid":_vm.className(' .chat-box')}}),_c('sid-linked-group',{attrs:{"label":"Padding","sid":_vm.className(' .chat-box'),"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Chat Login"}},[_c('div',{staticClass:"flex justify-between items-center mb-4"},[_c('label',{staticClass:"pb-0"},[_vm._v("Preview Login View")]),_c('b-checkbox',{staticClass:"mt-0",attrs:{"switch":""},model:{value:(_vm.section.options.content.showLogin),callback:function ($$v) {_vm.$set(_vm.section.options.content, "showLogin", $$v)},expression:"section.options.content.showLogin"}})],1),_c('b-form-group',{attrs:{"label":"Community Login Text"}},[_c('b-input',{staticClass:"w-full",attrs:{"type":"text"},model:{value:(_vm.section.options.content.loginText),callback:function ($$v) {_vm.$set(_vm.section.options.content, "loginText", $$v)},expression:"section.options.content.loginText"}})],1),_c('image-upload',{staticClass:"w-100 mb-4",attrs:{"image":_vm.section.options.content.image},on:{"imageDeleted":_vm.deleteImage,"uploaded":_vm.uploadedImage}}),_c('SidbearSettingsGroup',{attrs:{"title":"Login Title"}},[_c('sid-font',{attrs:{"sid":_vm.className(' .chat-login .chat-login-title')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' .chat-login .chat-login-title'),"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":_vm.className(' .chat-login .chat-login-title')}})],1)])],1),_c('SidbearSettingsGroup',{attrs:{"title":"Login Field"}},[_c('sid-font',{attrs:{"sid":_vm.className(' .chat-login .chat-login-field')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' .chat-login .chat-login-field'),"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":_vm.className(' .chat-login .chat-login-field')}})],1)]),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Placeholder Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":_vm.className(' .chat-login .chat-login-field::placeholder')}})],1)]),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Background Color")]),_c('sid-color',{attrs:{"rule-name":"background-color","sid":_vm.className(' .chat-login.chat-box .chat-login-field')}})],1)]),_c('sid-linked-group',{attrs:{"label":"Radius","sid":_vm.className(' .chat-login .chat-login-field'),"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
          {
            text: '',
            value: 'top-left-radius',
            cssVar: '--border-top-left-radius'
          },
          {
            text: '',
            value: 'top-right-radius',
            cssVar: '--border-top-right-radius'
          },
          {
            text: '',
            value: 'bottom-left-radius',
            cssVar: '--border-bottom-left-radius'
          },
          {
            text: '',
            value: 'bottom-right-radius',
            cssVar: '--border-bottom-right-radius'
          }
        ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Login Button"}},[_c('sid-font',{attrs:{"sid":_vm.className(' .chat-login.chat-box .chat-login-button')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' .chat-login.chat-box .chat-login-button'),"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":_vm.className(' .chat-login.chat-box .chat-login-button')}})],1)]),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Background Color")]),_c('sid-color',{attrs:{"rule-name":"background-color","sid":_vm.className(' .chat-login.chat-box .chat-login-button')}})],1)]),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Icon Color")]),_c('sid-color',{attrs:{"rule-name":"color","sid":_vm.className(' .chat-login .chat-login-button .form-icon')}})],1)]),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Icon Background Color")]),_c('sid-color',{attrs:{"rule-name":"background-color","sid":_vm.className(' .chat-login.chat-box .chat-login-button .form-icon')}})],1)]),_c('sid-linked-group',{attrs:{"label":"Radius","sid":_vm.className(' .chat-login .chat-login-button'),"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
          {
            text: '',
            value: 'top-left-radius',
            cssVar: '--border-top-left-radius'
          },
          {
            text: '',
            value: 'top-right-radius',
            cssVar: '--border-top-right-radius'
          },
          {
            text: '',
            value: 'bottom-left-radius',
            cssVar: '--border-bottom-left-radius'
          },
          {
            text: '',
            value: 'bottom-right-radius',
            cssVar: '--border-bottom-right-radius'
          }
        ]}})],1)],1),_c('SidbearSettingsGroup',{attrs:{"title":"Username"}},[_c('sid-font',{attrs:{"sid":_vm.className(' .chat-box .message .message-user-name')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' .chat-box .message .message-user-name'),"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","var":"--title-color","sid":_vm.className(' .chat-box .message .message-user-name')}})],1)])],1),_c('SidbearSettingsGroup',{attrs:{"title":"Text Messages"}},[_c('rule-tabs',{attrs:{"tabs":['Normal', 'Replied']},scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-font',{attrs:{"sid":_vm.className(' .chat-box .message .msg')}}),_c('sid-background',{attrs:{"sid":_vm.className(' .chat-box .message')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' .chat-box .message .msg'),"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","var":"--title-color","sid":_vm.className(' .chat-box .message .msg')}})],1)]),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":_vm.className(' .chat-box .message'),"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":_vm.className(' .chat-box .message'),"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":_vm.className(' .chat-box .message'),"rule-name":"border-color"}})],1)],1),_c('b-form-group',[_c('sid-linked-group',{attrs:{"label":"Radius","sid":_vm.className(' .chat-box .message'),"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
              {
                text: '',
                value: 'top-left-radius',
                cssVar: '--border-top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius',
                cssVar: '--border-top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius',
                cssVar: '--border-bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius',
                cssVar: '--border-bottom-right-radius'
              }
            ]}})],1),_c('b-form-group',[_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Margin","sid":_vm.className(' .chat-box .message'),"rule-name":"margin","min":-2000,"max":2000,"angles":[
              {
                text: '',
                value: 'top'
              },
              {
                text: '',
                value: 'right'
              },
              {
                text: '',
                value: 'bottom'
              },
              {
                text: '',
                value: 'left'
              }
            ]}})],1),_c('sid-linked-group',{attrs:{"label":"Padding","sid":_vm.className(' .chat-box .message'),"rule-name":"padding","min":0,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true},{key:"Replied",fn:function(){return [_c('sid-font',{attrs:{"sid":_vm.className(' .chat-box .message.replied .msg')}}),_c('sid-background',{attrs:{"sid":_vm.className(' .chat-box .message.replied')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' .chat-box .message.replied .msg'),"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","var":"--title-color","sid":_vm.className(' .chat-box .message.replied .msg')}})],1)]),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":_vm.className(' .chat-box .message.replied'),"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":_vm.className(' .chat-box .message.replied'),"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":_vm.className(' .chat-box .message.replied'),"rule-name":"border-color"}})],1)],1),_c('b-form-group',[_c('sid-linked-group',{attrs:{"label":"Radius","sid":_vm.className(' .chat-box .message.replied'),"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
              {
                text: '',
                value: 'top-left-radius',
                cssVar: '--border-top-left-radius'
              },
              {
                text: '',
                value: 'top-right-radius',
                cssVar: '--border-top-right-radius'
              },
              {
                text: '',
                value: 'bottom-left-radius',
                cssVar: '--border-bottom-left-radius'
              },
              {
                text: '',
                value: 'bottom-right-radius',
                cssVar: '--border-bottom-right-radius'
              }
            ]}})],1),_c('b-form-group',[_c('sid-linked-group',{staticClass:"mb-0",attrs:{"label":"Margin","sid":_vm.className(' .chat-box .message.replied'),"rule-name":"margin","min":-2000,"max":2000,"angles":[
              {
                text: '',
                value: 'top'
              },
              {
                text: '',
                value: 'right'
              },
              {
                text: '',
                value: 'bottom'
              },
              {
                text: '',
                value: 'left'
              }
            ]}})],1),_c('sid-linked-group',{attrs:{"label":"Padding","sid":_vm.className(' .chat-box .message.replied'),"rule-name":"padding","min":0,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Composer"}},[_c('rule-tabs',{attrs:{"tabs":['Normal', 'Placeholder']},scopedSlots:_vm._u([{key:"Normal",fn:function(){return [_c('sid-font',{attrs:{"sid":_vm.className(' .composer-wrapper .composer')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' .composer-wrapper .composer'),"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","var":"--title-color","sid":_vm.className(' .composer-wrapper .composer')}})],1)]),_c('sid-background',{attrs:{"sid":_vm.className(' .composer-wrapper .composer')}}),_c('sid-background',{attrs:{"label":"Wrapper","sid":_vm.className(' .composer-wrapper')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"rule-name":"height","sid":_vm.className(' .composer-wrapper .composer'),"default-dimension":"px","dimensions":['px', 'vh', '%'],"label":"Height","var":"--height","reset-value":"300px","measurement":"height"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Border Type")]),_c('sid-select',{staticClass:"w-[118px]",attrs:{"sid":_vm.className(' .composer-wrapper .composer'),"rule-name":"border-style","searchable":false,"options":[{label: 'Solid', value: 'solid'}, {label: 'Dashed', value: 'dashed'}, {label: 'Dotted', value: 'dotted'}, {label: 'Double', value: 'double'}, {label: 'Outset', value: 'outset'}]}})],1)]),_c('b-form-group',[_c('sid-linked-group',{staticClass:"!mb-[7px]",attrs:{"sid":_vm.className(' .composer-wrapper .composer'),"label":"Border Width","rule-name":"border","css-var":"--border-size","angles":[
              {
                text: '',
                value: 'top-width'
              },
              {
                text: '',
                value: 'right-width'
              },
              {
                text: '',
                value: 'bottom-width'
              },
              {
                text: '',
                value: 'left-width'
              }
            ]}}),_c('div',{staticClass:"flex w-full justify-end"},[_c('sid-color',{attrs:{"sid":_vm.className(' .composer-wrapper .composer'),"rule-name":"border-color"}})],1)],1),_c('sid-linked-group',{attrs:{"label":"Radius","sid":_vm.className(' .composer-wrapper .composer'),"rule-name":"border","titles":['top-l', 'top-r', 'bottom-l', 'bottom-r'],"angles":[
            {
              text: '',
              value: 'top-left-radius',
              cssVar: '--border-top-left-radius'
            },
            {
              text: '',
              value: 'top-right-radius',
              cssVar: '--border-top-right-radius'
            },
            {
              text: '',
              value: 'bottom-left-radius',
              cssVar: '--border-bottom-left-radius'
            },
            {
              text: '',
              value: 'bottom-right-radius',
              cssVar: '--border-bottom-right-radius'
            }
          ]}}),_c('sid-linked-group',{attrs:{"label":"Padding","sid":_vm.className(' .composer-wrapper .composer'),"rule-name":"padding","min":0,"angles":[
            {
              text: '',
              value: 'top'
            },
            {
              text: '',
              value: 'right'
            },
            {
              text: '',
              value: 'bottom'
            },
            {
              text: '',
              value: 'left'
            }
          ]}})]},proxy:true},{key:"Placeholder",fn:function(){return [_c('sid-font',{attrs:{"sid":_vm.className(' .online-status::placeholder')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' .composer-wrapper .composer::placeholder'),"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","var":"--title-color","sid":_vm.className(' .composer-wrapper .composer::placeholder')}})],1)])]},proxy:true}])})],1),_c('SidbearSettingsGroup',{attrs:{"title":"Time & Date"}},[_c('b-checkbox',{attrs:{"switch":""},model:{value:(_vm.section.options.content.chat.showTimestamp),callback:function ($$v) {_vm.$set(_vm.section.options.content.chat, "showTimestamp", $$v)},expression:"section.options.content.chat.showTimestamp"}},[_vm._v(" Show Timestamp ")])],1),_c('SidbearSettingsGroup',{attrs:{"title":"Live Emojis"}},[_c('b-checkbox',{attrs:{"switch":""},model:{value:(_vm.section.options.content.chat.showFlyEmojis),callback:function ($$v) {_vm.$set(_vm.section.options.content.chat, "showFlyEmojis", $$v)},expression:"section.options.content.chat.showFlyEmojis"}},[_vm._v(" Enable ")])],1),_c('SidbearSettingsGroup',{attrs:{"title":"Live Chat Sticky Message"}},[_c('tiptap-v2',{model:{value:(_vm.section.options.content.pinnedMessage),callback:function ($$v) {_vm.$set(_vm.section.options.content, "pinnedMessage", $$v)},expression:"section.options.content.pinnedMessage"}}),_c('b-form-group',[_c('div',{staticClass:"flex gap-[6px]"},[_c('button',{staticClass:"hover:opacity-60 flex justify-center font-bold text-dark border items-center text-[13px] rounded h-[29px] !px-[16px] py-0",on:{"click":_vm.setPinnedMessage}},[_vm._v(" Update Message ")]),_c('button',{staticClass:"hover:opacity-60 flex justify-center font-bold text-dark border bg-[#F4F4F4] items-center text-[13px] rounded h-[29px] !px-[16px] py-0",on:{"click":_vm.removePinnedMessage}},[_vm._v(" Remove ")])])]),_c('sid-font',{attrs:{"sid":_vm.className(' .pinned-message')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' .pinned-message'),"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","var":"--title-color","sid":_vm.className(' .pinned-message')}})],1)]),_c('sid-background',{attrs:{"sid":_vm.className(' .pinned-message')}}),_c('sid-linked-group',{attrs:{"label":"Padding","sid":_vm.className(' .pinned-message'),"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1),_c('SidbearSettingsGroup',{attrs:{"title":"User Ban Message"}},[_c('b-form-group',[_c('b-textarea',{model:{value:(_vm.section.options.content.chat.banMessage),callback:function ($$v) {_vm.$set(_vm.section.options.content.chat, "banMessage", $$v)},expression:"section.options.content.chat.banMessage"}})],1),_c('sid-font',{attrs:{"sid":_vm.className(' .ban-message')}}),_c('b-form-group',[_c('sid-range-slider',{attrs:{"label":"Font Size","sid":_vm.className(' .ban-message'),"rule-name":"font-size"}})],1),_c('b-form-group',[_c('div',{staticClass:"flex items-center justify-between"},[_c('label',{staticClass:"pb-0"},[_vm._v("Text Color")]),_c('sid-color',{attrs:{"rule-name":"color","var":"--title-color","sid":_vm.className(' .ban-message')}})],1)]),_c('sid-background',{attrs:{"sid":_vm.className(' .ban-message')}}),_c('sid-linked-group',{attrs:{"label":"Padding","sid":_vm.className(' .ban-message'),"rule-name":"padding","min":0,"angles":[
        {
          text: '',
          value: 'top'
        },
        {
          text: '',
          value: 'right'
        },
        {
          text: '',
          value: 'bottom'
        },
        {
          text: '',
          value: 'left'
        }
      ]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }